import React, { useEffect, useState, useMemo } from "react"
import api from "API/Api"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import { usePermissions } from "API/PermissionContext"

const arr = d => { const v = d?.data?.data ?? d?.data ?? d; return Array.isArray(v) ? v : [] }

const CenterMilkSales = () => {
  const { MODULE } = usePermissions()
  const MID = MODULE.CENTER_MILK_SALES

  const [records, setRecords] = useState([])
  const [pageLoad, setPageLoad] = useState(true)
  const [searchTxt, setSearchTxt] = useState("")
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  // filter
  const [showFilter, setShowFilter] = useState(false)
  const [fCompany, setFCompany] = useState("")
  const [fPlant, setFPlant] = useState("")
  const [fCC, setFCC] = useState("")
  const [fDate, setFDate] = useState("")
  const [fDateTo, setFDateTo] = useState("")
  const [fShift, setFShift] = useState("")

  useEffect(() => { loadData(1) }, [])

  const loadData = async (p) => {
    setPageLoad(true)
    try {
      const resp = await api.get("center-milk-sales?per_page=200&page=" + (p || 1))
      const d = resp.data?.data
      setRecords(d?.data || arr(resp))
      setPage(d?.current_page || 1)
      setTotalPages(d?.last_page || 1)
    } catch (e) { setRecords([]) }
    setPageLoad(false)
  }

  const filtered = useMemo(() => {
    let d = records
    if (searchTxt) {
      const s = searchTxt.toLowerCase()
      d = d.filter(r =>
        (r.companyName || "").toLowerCase().includes(s) ||
        (r.plantName || "").toLowerCase().includes(s) ||
        (r.ccName || "").toLowerCase().includes(s) ||
        (r.routeName || "").toLowerCase().includes(s) ||
        (r.centerName || "").toLowerCase().includes(s) ||
        (r.saleDate || "").includes(s) ||
        String(r.serial || "").includes(s)
      )
    }
    if (fCompany) d = d.filter(r => (r.companyName || "").toLowerCase().includes(fCompany.toLowerCase()))
    if (fPlant) d = d.filter(r => (r.plantName || "").toLowerCase().includes(fPlant.toLowerCase()))
    if (fCC) d = d.filter(r => (r.ccName || "").toLowerCase().includes(fCC.toLowerCase()))
    if (fDate) d = d.filter(r => r.saleDate >= fDate)
    if (fDateTo) d = d.filter(r => r.saleDate <= fDateTo)
    if (fShift) d = d.filter(r => String(r.shift) === fShift)
    return d
  }, [records, searchTxt, fCompany, fPlant, fCC, fDate, fDateTo, fShift])

  const milkLabel = t => t == 1 ? "Cow" : t == 2 ? "Buffalo" : "Common"
  const shiftLabel = s => s == 0 || s === "0" ? "AM" : "PM"

  const Pager = ({ cur, total, onChange }) => (
    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4, marginTop: 8 }}>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(1)} disabled={cur <= 1}>--</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur - 1)} disabled={cur <= 1}>&lt;</button>
      <span style={{ padding: "2px 10px", background: "#0d6efd", color: "#fff", borderRadius: 4, fontSize: 13 }}>{cur}</span>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur + 1)} disabled={cur >= total}>&gt;</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(total)} disabled={cur >= total}>--</button>
    </div>
  )

  const ib = (bg, icon, title, onClick) => (
    <button title={title} onClick={onClick}
      style={{ width: 32, height: 32, borderRadius: 4, background: bg, color: "#fff", border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14, cursor: "pointer" }}>
      <i className={`fas ${icon}`} />
    </button>
  )

  return (
    <>
      {/* Toolbar: Title + Filter + Search in one row */}
      <div style={{
        display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px",
        marginBottom: "10px", background: "#f8f9fa",
        borderRadius: "8px", padding: "4px 8px", border: "1px solid #dee2e6",
      }}>
        <h5 style={{ fontWeight: 600, color: "#2563eb", margin: 0, marginRight: 10, fontSize: 16, whiteSpace: "nowrap" }}>Center Milk Sales</h5>
        <div style={{ width: 1, height: 24, background: "#dee2e6", margin: "0 2px" }} />
        {ib("#0d6efd", "fa-filter", "Toggle Filter", () => {
          setShowFilter(!showFilter)
          if (showFilter) { setFCompany(""); setFPlant(""); setFCC(""); setFDate(""); setFDateTo(""); setFShift("") }
        })}

        <div style={{ flex: 1 }} />

        <div style={{ display: "flex", gap: 4 }}>
          <input className="form-control form-control-sm" style={{ width: 180, fontSize: 13 }} placeholder="Search" value={searchTxt} onChange={e => setSearchTxt(e.target.value)} />
          <button className="btn btn-sm btn-primary" style={{ padding: "2px 8px" }}><i className="fas fa-search" /></button>
        </div>
      </div>

      {/* Loader / Content */}
      {pageLoad ? <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div> : (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-sm table-bordered table-hover mb-0 dairyTbl" style={{ fontSize: 12 }}>
            <thead style={{ background: "#f8f9fa" }}>
              <tr>
                <th>#</th>
                <th>Company</th><th>Plant</th><th>Chilling Center</th>
                <th>Route</th><th>Center</th>
                <th>Date</th><th>Shift</th><th>Serial</th><th>Milk</th>
                <th>Qty (Ltrs)</th><th>Rate</th><th>Sale Time</th>
              </tr>
              {showFilter && (
                <tr style={{ background: "#f1f3f5" }}>
                  <td></td>
                  <td><input className="form-control form-control-sm" placeholder="Company" value={fCompany} onChange={e => setFCompany(e.target.value)} /></td>
                  <td><input className="form-control form-control-sm" placeholder="Plant" value={fPlant} onChange={e => setFPlant(e.target.value)} /></td>
                  <td><input className="form-control form-control-sm" placeholder="CC" value={fCC} onChange={e => setFCC(e.target.value)} /></td>
                  <td></td><td></td>
                  <td>
                    <input type="date" className="form-control form-control-sm" value={fDate} onChange={e => setFDate(e.target.value)} />
                    <input type="date" className="form-control form-control-sm mt-1" value={fDateTo} onChange={e => setFDateTo(e.target.value)} />
                  </td>
                  <td>
                    <select className="form-control form-control-sm" value={fShift} onChange={e => setFShift(e.target.value)}>
                      <option value="">All</option><option value="0">AM</option><option value="1">PM</option>
                    </select>
                  </td>
                  <td colSpan={4}></td>
                  <td>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => { setFCompany(""); setFPlant(""); setFCC(""); setFDate(""); setFDateTo(""); setFShift("") }}>
                      <i className="fa fa-times" />
                    </button>
                  </td>
                </tr>
              )}
            </thead>
            <tbody>
              {filtered.length > 0 ? filtered.map((r, i) => (
                <tr key={r.id || i}>
                  <td>{i + 1}</td>
                  <td>{r.companyName || r.company || "-"}</td>
                  <td>{r.plantName || r.plant || "-"}</td>
                  <td>{r.ccName || r.chillingCenter || "-"}</td>
                  <td>{r.routeName || r.route || "-"}</td>
                  <td>{r.centerName || r.collectionCenter || "-"}</td>
                  <td style={{ whiteSpace: "nowrap", fontSize: 11 }}>{r.saleDate}</td>
                  <td><span className={`badge bg-${r.shift == 0 ? "info" : "warning"}`}>{shiftLabel(r.shift)}</span></td>
                  <td>{r.serial || "-"}</td>
                  <td><span className={`badge bg-${r.milkType == 1 ? "primary" : r.milkType == 2 ? "success" : "secondary"}`}>{milkLabel(r.milkType)}</span></td>
                  <td><strong>{r.qtyLtrs}</strong></td>
                  <td>{r.rate || "-"}</td>
                  <td style={{ fontSize: 11 }}>{r.saleTime || "-"}</td>
                </tr>
              )) : (
                <tr><td colSpan={13}><center style={{ padding: 20, color: "#6c757d" }}>No matching records found</center></td></tr>
              )}
            </tbody>
          </table>
          <Pager cur={page} total={totalPages} onChange={p => loadData(p)} />
        </div>
      )}
    </>
  )
}

export default CenterMilkSales
